import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  templateUrl: "./outdated-version.component.html",
  styleUrls: ["./outdated-version.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

/** Modal will appear with outdated app message
 * this modal covers only mat-sidenav-content portion
 */
export class OutdatedConfigVersionComponent {}
